import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import loadAllAccessorials from "@tKgpco/Handlers/Accessorials/LoadAccessorials";
import searchFilterAccessorials from "@tKgpco/Handlers/Accessorials/SearchFilterAccessorials";
import { deleteAccessorial } from "@tKgpco/Services/AccessorialsService";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";
import { Accessorial } from "@tKgpco/Store/Data/Accessorials/AccessorialsState";

type Parameters = { id: string } & HasOnSuccess & HasOnError;
type HandlerType = CustomApiHandler<Parameters, Accessorial>;

export const BeginDeleteAccessorial: HandlerType = props => {
    props.dispatch({ type: "Custom/Accessorials/ShowOverlay" });
};

export const RequestDataFromApi: HandlerType = props => {
    return deleteAccessorial(props.parameter.id);
};

export const LoadAccessorials: HandlerType = props => {
    props.dispatch(searchFilterAccessorials({ queryParams: { page: 1 } }));
};

export const CompleteDeleteAccessorial: HandlerType = props => {
    props.dispatch({
        type: "Custom/Accessorials/HideOverlay",
    });
};

export const ExecuteOnSuccess: HandlerType = props => {
    props.parameter.onSuccess?.();
};

export const chain = [
    BeginDeleteAccessorial,
    RequestDataFromApi,
    LoadAccessorials,
    CompleteDeleteAccessorial,
    ExecuteOnSuccess,
];

const removeAccessorial = createHandlerChainRunner(chain, "CustomLoadAccessorial");
export default removeAccessorial;
